module.exports = __webpack_public_path__ + "img/404.74f870d4.svg";